module.exports = __webpack_public_path__ + "static/logistics-collect-goods@3x-4dddd67790d72e6c489e317b9dd55adf.png";